<button mat-flat-button color="secondary" [matMenuTriggerFor]="createButtonMenu">
    <span class="flex-row items-center gap-4">CREATE <mat-icon>arrow_drop_down</mat-icon></span>
</button>
<mat-menu #createButtonMenu="matMenu">
    <button mat-menu-item (click)="createApplication()">Application Doc</button>
    @if (showNewSubmittal()) {
        <button mat-menu-item (click)="onNewSubmittal()">PerDiem Submittal from Scratch</button>
    }
    <button mat-menu-item (click)="onTicket()">Ticket</button>
</mat-menu>
